// extracted by mini-css-extract-plugin
export default {"subscribeContainer":"Subscribe_subscribeContainer__CQdKU","subscribe":"Subscribe_subscribe__ncdGc","submitBtn":"Subscribe_submitBtn__Bke9k"};